export default "__VITE_ASSET__B3_fsbJQ__"